import { createApiEffect } from '@/features/api/common/create-api-effect'
import { Employee } from '@/features/api/employee/types'

export const getSelfUserFx = createApiEffect<void, Employee>({
  requestMapper: () => ({
    method: 'GET',
    url: `/api/user-app/employee/me/`,
  }),
})
